<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue';
export default {
  data () {
    return {
      cdata: {
        xData: ["冷水表", "热水表", "电表", "汽表"],
        seriesData: [
          { value: 86, name: "冷水表" },
          { value: 92, name: "热水表" },
          { value: 115, name: "电表" },
          { value: 70, name: "汽表" }
        ]
      }
    }
  },
  components: {
    Chart,
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>